import { render } from "./WSCreate.vue?vue&type=template&id=1fca3df6&ts=true"
import script from "./WSCreate.vue?vue&type=script&lang=ts"
export * from "./WSCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__